import { GridColDef, GridRowParams } from '@mui/x-data-grid-pro'
import { DataCollection } from '../../../Typescript/StuartPy/DataCollection'
import { formatValueDateTime } from '../../../Functions/FormatValues'

type fieldeColDef = GridColDef & {
  field: keyof DataCollection
  getActions?: (a: GridRowParams) => any
}

export const DataCollectionCols: fieldeColDef[] = [
  {
    field: 'StartTime',
    headerName: 'Start Time',
    flex: 1,
    valueFormatter: (value: any) => formatValueDateTime(value),
  },
  {
    field: 'EmployeeID',
    headerName: 'Employee',
    flex: 1,
  },
  {
    field: 'ExpirationTime',
    headerName: 'Expiration',
    flex: 1,
    valueFormatter: (value: any) => formatValueDateTime(value),
  },
  {
    field: 'SheetsID',
  },
  {
    field: 'SpreadsheetID',
  },
]
